'use client';

import { Box, Text, useToken } from '@chakra-ui/react';

interface SalePointCardProps {
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
}

const SalePointCard = ({ title, subtitle, icon }: SalePointCardProps) => {
  const [common0, brand50] = useToken('colors', ['common.0', 'brand.50']);
  return (
    <Box
      background={`linear-gradient(to bottom right, ${common0}, ${brand50})`}
      borderRadius="16px"
      height={{ base: '120px', tablet: '145px' }}
      padding={{ base: 4, tablet: 6 }}
      width="100%"
    >
      {icon && <Box marginBottom={{ base: 2, tablet: 3 }}>{icon}</Box>}
      <Text color="common.100" textStyle="title3" fontWeight="medium" marginBottom={{ base: 2, tablet: 3 }}>
        {title}
      </Text>
      <Text
        color="text.primary.inverse"
        textStyle={{ base: 'body3', tablet: 'body2' }}
        fontWeight="regular"
        maxWidth={{ base: '100%', tablet: '200px' }}
      >
        {subtitle}
      </Text>
    </Box>
  );
};

export default SalePointCard;
